// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5665":"81b20576","6201":"c0af674d","6611":"81b20576","8898":"1077335f"}[chunkId] + ".chunk.css";
};